export const loadClientDashboardState = () => {
    try {
      const serializedState = localStorage.getItem('clientDashboardState');
      if (serializedState === null) {
        return undefined; // No saved state
      }
      return JSON.parse(serializedState);
    } catch (error) {
      console.error('Error loading client dashboard state', error);
      return undefined;
    }
  };
  
  export const saveClientDashboardState = (state) => {
    try {
      const serializedState = JSON.stringify(state);
      localStorage.setItem('clientDashboardState', serializedState);
    } catch (error) {
      console.error('Error saving client dashboard state', error);
    }
  };
  